module.exports = __webpack_public_path__ + "static/media/招标代理5A资信@2x.18e46aaf.png";